import confetti from "canvas-confetti";
import { random } from "lodash";
import { useCallback, useEffect, useRef } from "react";

export const useConfetti = () => {
  const confettiRef = useRef<confetti.CreateTypes>();

  const resetConfetti = useCallback(() => {
    confettiRef.current?.reset?.();
  }, []);

  const triggerConfetti = useCallback((confettiCanvas: HTMLCanvasElement) => {
    if (confettiCanvas) {
      if (!confettiRef.current) {
        confettiRef.current = confetti.create(confettiCanvas, {
          useWorker: false, // Cannot use web workers with multiple canvases.
          // Confetti would only pop on a single scheduling-link-card otherwise.
          resize: true,
        });
      }

      void confettiRef.current({
        // Left to right, orginating from near the copy button
        particleCount: random(80, 120),
        spread: random(50, 150),
        startVelocity: random(18, 26),
        ticks: random(280, 320),
        drift: random(1, 6) / 10,
        origin: { x: 0.2, y: 1.2 }, // Sets it to pop from the copy button.
        angle: random(52, 70),
        colors: ["#FFFFFF", "#FFDE34"], // #FFDE34 is emoji yellow
        scalar: 0.2,
        disableForReducedMotion: true,
      });
    }
  }, []);

  useEffect(
    () => () => {
      // Reset confetti when the component unmounts
      resetConfetti();
    },
    [resetConfetti],
  );

  return { triggerConfetti, resetConfetti };
};
